import React from "react";

import { StyledSVG } from "../StyledIcon";

export const DataHubIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <rect
        width="8.80166"
        height="8.80166"
        transform="matrix(0.818026 0.575181 -0.818026 0.575181 9 2.25)"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        width="8.80164"
        height="8.80164"
        transform="matrix(0.818027 0.57518 -0.818027 0.57518 9 5.625)"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
